import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Avatar } from "./Avatar.vue"
export { getInitials } from "./initials"
export { AVATAR_PALETTE_SIZE, getAvatarPalette } from "./palette"

export const avatarVariants = cva(
  "relative inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-muted font-medium text-muted-foreground",
  {
    variants: {
      size: {
        sm: "size-8 text-xs",
        md: "size-10 text-sm",
        lg: "size-12 text-base",
        xl: "size-24 text-2xl",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)
export type AvatarVariants = VariantProps<typeof avatarVariants>
